import { api } from 'guardian-js-shared';
import { getContextAuthResource } from 'speed-js-core';

export default {
    ...api.resources,
    auth: getContextAuthResource('service_provider'),
};
